"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Routes = void 0;
var Routes;
(function (Routes) {
    Routes["LOG_ACTIONS"] = "/api/v1/collection/log-actions";
    Routes["LOG_SIGNUP_ACTIONS"] = "/api/v1/collection/log-signup-actions";
    Routes["LOG_SERVICE_USER_ACTIONS"] = "/api/v1/collection/log-service-user-actions";
})(Routes || (exports.Routes = Routes = {}));
